import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import login from './modules/login'

Vue.use(Vuex)

const _store = new Vuex.Store({
    modules: {
        app,
        user,
        login,
    },
})

export default _store
